var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 24.5H10.8C8.81 24.5 7.2 22.89 7.2 20.9V17.3H3.6C1.61 17.3 0 15.69 0 13.7V4.1C0 2.11 1.61 0.5 3.6 0.5H13.2C15.19 0.5 16.8 2.11 16.8 4.1V7.7H20.4C22.39 7.7 24 9.31 24 11.3V20.9C24 22.89 22.39 24.5 20.4 24.5ZM9.6 16.1V20.9C9.6 21.56 10.14 22.1 10.8 22.1H20.4C21.06 22.1 21.6 21.56 21.6 20.9V11.3C21.6 10.64 21.06 10.1 20.4 10.1H10.8C10.14 10.1 9.6 10.64 9.6 11.3V16.1ZM3.6 2.9C2.94 2.9 2.4 3.44 2.4 4.1V13.7C2.4 14.36 2.94 14.9 3.6 14.9H7.2V11.3C7.2 9.31 8.81 7.7 10.8 7.7H14.4V4.1C14.4 3.44 13.86 2.9 13.2 2.9H3.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.37d240612b764d329b334f46e9b2c909.svg";
export { ForwardRef as ReactComponent };